import React, { useContext, useEffect, useState } from 'react'
import Container from '../../components/common/Container'
import Banner from '../../components/common/Banner'
import { Link } from 'react-router-dom'
import Allsportdata from '../../components/allsportdata/Allsportdata'
import inPlaybanner from '../../assets/images/in_Playe_Page_Top.png'
import sidebarCard1 from '../../assets/images/cas-1.png'
import sidebarCard2 from '../../assets/images/cas-2.png'
import sidebarCard3 from '../../assets/images/cas-3.png'
import FeatureEvent from '../../components/common/FeatureEvent/FeatureEvent'
import useSocket from '../../Websoket.js';
import { PopupContext } from "../../components/LoginPopup/LoginPopupContext.js";
import SliderReusable from '../../components/sliderreusable/SliderReusable.js'
import AllsportdataTest from '../../components/allsportdata/AllsportdataTest.js'
import { SocketContext } from '../../SocketContext.js'

function Inplay() {
    document.title = 'Inplay';
  const [matchdata, setMatchData] = useState([]);
  const [endPoint, setEndPoint] = useState('cricket');
  const [activeTab, setActiveTab] = useState('Cricket');
  const [selectedTypes, setSelectedTypes] = useState("time");
  const { isConnected, sendMessage,getAllBets } = useContext(SocketContext);
  const [firstTimeCall, setFirstTimeCall] = useState(false)
  const { loggedIn } = useContext(PopupContext);
  const [countArray, setCountArray] = useState([]);

  useEffect(() => {    
          let intervalId;
          if (isConnected) {
              let matchdata = null;
              let userData = sessionStorage.getItem('userId')
              if(userData){
                  matchdata =  {
                      "id": userData
                  }
              }else{
                  matchdata = ""
              }
              if (!firstTimeCall) {
                  setFirstTimeCall(true)
                  sendMessage('AllOPenBets', matchdata);                
              }
              intervalId = setInterval(() => {
                  sendMessage('AllOPenBets', matchdata);
              }, 5000);
          }
          return () => {
              if (intervalId) {
                  clearInterval(intervalId);
              }
          };
      }, [isConnected, sendMessage, getAllBets]);

      const countAPI = () => {
        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
    
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };
    
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/games/liveCountData`,
          requestOptions
        )
          .then(async (response) => {
            let paresData = await response.json();
            setCountArray([]);
            setCountArray(paresData.result);
          })
          .catch((error) => {
            console.log(error);
          });
      };


        useEffect(() => {
          countAPI(); // Initial fetch
          const interval = setInterval(() => {
            countAPI();
          }, 60000); // 60000ms = 1 minute
      
          return () => clearInterval(interval); // Cleanup on unmount
        }, []);

    const fetchData = async (currentTab, selectedTypes) => {
      try {
        const filter = Array.isArray(selectedTypes)
          ? selectedTypes.join(',')
          : selectedTypes;

        const url = `${process.env.REACT_APP_BASE_URL}/api/v1/games/getInplayData?type=${currentTab}&filter=${filter}`;
        console.log("API URL:", url);

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        setMatchData(data);
        const key = `${currentTab}_inplay`;
        localStorage.setItem(key, JSON.stringify(data));
      } catch (error) {
        console.error("Fetch or storage error:", error);
      }
    };


    const handleTypeChange = (event) => {
        setSelectedTypes(event.target.value);
        // fetchData(endPoint,event.target.value);
      };

    useEffect(() => {
        if (localStorage.getItem(`${endPoint}_inplay`)) {
          let data = JSON.parse(localStorage.getItem(`${endPoint}_inplay`))
          setMatchData(data);            
        }
        fetchData(endPoint,selectedTypes);
        const interval = setInterval(() => { fetchData(endPoint,selectedTypes); }, 60000);
        return () => clearInterval(interval);
    }, [endPoint,selectedTypes]);

    const handleTab =(currentTab) => {
        setActiveTab(currentTab);
        let data = "All"
        if(currentTab === 'Cricket'){
            setEndPoint('cricket');
            data = 'cricket';
        }else if(currentTab === 'Football'){
            setEndPoint('football');
            data = 'football';
        }else if(currentTab === 'Tennis'){
            setEndPoint('tennis');
            data = 'tennis';
        }else if(currentTab === 'Election'){
            setEndPoint('election');
            data = 'election';
        }else if(currentTab === 'Kabaddi'){
            setEndPoint('kabaddi');
            data = 'kabaddi';
        }else if(currentTab === 'HorseRacing'){
            setEndPoint('horseracing');
            data = 'horseracing';
        }else if(currentTab === 'GreyhoundRacing'){
            setEndPoint('greyhound');
            data = 'greyhound';
        }if(currentTab === 'All'){
            setEndPoint('All');
            data = 'All';
        }
        // fetchData(data,selectedTypes)
    }

    const getCount = (type) => {
      return countArray.find(item => item.name === type)?.count || 0;
    }

    const getAllSportCount = () => {
      return countArray.reduce((sum, item) => sum + item.count, 0);
    }

    const homeSliderSettings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 1000,
      infinite: true,
      autoplaySpeed: 2000,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%',
          },
        }
      ],
    };

     const [assetsData, setAssetsData] = useState([]);

        useEffect(() => {
          if (localStorage.getItem('AssetsData_inplay')) {
            let data = JSON.parse(localStorage.getItem('AssetsData_inplay'))
            setAssetsData(data);            
          }
          const fetchData = async () => {
            try {
              const response = await fetch(`${process.env.REACT_APP_BASE_URL}/inplayPageBanner`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  'whiteLabelName': window.location.hostname,
                }),
              });
    
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
    
              const data = await response.json();
              let maindata = data.banner.filter(item => item.status === true);
              localStorage.setItem("AssetsData_inplay", JSON.stringify(maindata));
              setAssetsData(maindata);
            } catch (error) {
              console.error('Fetch error:', error);
            }
          };
    
          fetchData();
        }, []);


  return (
    <Container size='full'>
    <div className='mobile-sport-menu'>
    <ul>
        <li><span onClick={()=>handleTab("All")} className={`mobile-tab-btn ${activeTab === 'All' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='' src="../images/trophy.png" /></span> All Sports<strong className="live-count">{getAllSportCount()}</strong></span> </li>
        <li><span onClick={()=>handleTab("Cricket")} className={`mobile-tab-btn ${activeTab === 'Cricket' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Cricket' src='../images/cricket-ball.png' /></span> Cricket <strong className="live-count">{getCount('Cricket')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Football")} className={`mobile-tab-btn ${activeTab === 'Football' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Football' src='../images/football.png' /></span> Football <strong className="live-count">{getCount('Football')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Tennis")} className={`mobile-tab-btn ${activeTab === 'Tennis' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Tennis' src='../images/tennis.png' /></span> Tennis <strong className="live-count">{getCount('Tennis')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Election")} className={`mobile-tab-btn ${activeTab === 'Election' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Election' src='../images/mayor.png' /></span> Election <strong className="live-count">{getCount('Election')}</strong></span> </li>
        <li><span onClick={()=>handleTab("Kabaddi")} className={`mobile-tab-btn ${activeTab === 'Kabaddi' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Kabaddi' src='../images/kabaddi.png' /></span> Kabaddi <strong className="live-count">{getCount('Kabaddi')}</strong></span> </li>
        <li><span onClick={()=>handleTab("HorseRacing")} className={`mobile-tab-btn ${activeTab === 'HorseRacing' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Horse Racing' src='../images/horse.png' /></span> Horse Racing <strong className="live-count">{getCount('HorseRacing')}</strong></span> </li>
        <li><span onClick={()=>handleTab("GreyhoundRacing")} className={`mobile-tab-btn ${activeTab === 'GreyhoundRacing' ? 'active' :''}`}><span className='icon'><img decoding="async" loading="lazy" alt='Greyhound Racing' src='../images/dog.png' /></span> Greyhound Racing <strong className="live-count">{getCount('GreyHound')}</strong></span> </li>
    </ul>
    </div>
    <div className={`content-w-sidebar exchange-page`}>
    <div className='left-content'>
        <SliderReusable topSliderItem ={assetsData} settings={homeSliderSettings} className='home-top-slider' />
        { <div className='filter-btn-wrapper'>
        <FeatureEvent />
            <div className="filter-btn">
                <span>View by:</span>
                        <select name="filterby" id="filterby" value={selectedTypes} onChange={handleTypeChange}>
                            <option value="competitions" selected="">Competitions</option>
                            <option value="time">Time</option>
                        </select>

            </div>
        </div>}
        <div className='allsport-tab'>
        <span onClick={()=>handleTab("All")} className={`tab-btn ${activeTab === 'All' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='All Sports' src='../images/trophy.png' /> All Sports<strong className="live-count">{getAllSportCount()}</strong></span>
            <span onClick={()=>handleTab("Cricket")} className={`tab-btn ${activeTab === 'Cricket' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Cricket' src='../images/cricket-ball.png' /> Cricket<strong className="live-count">{getCount('Cricket')}</strong></span>
            <span onClick={()=>handleTab("Football")} className={`tab-btn ${activeTab === 'Football' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Football' src='../images/football.png' /> Football<strong className="live-count">{getCount('Football')}</strong></span>
            <span onClick={()=>handleTab("Tennis")} className={`tab-btn ${activeTab === 'Tennis' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Tennis' src='../images/tennis.png' />  Tennis<strong className="live-count">{getCount('Tennis')}</strong></span>
            <span onClick={()=>handleTab("Election")} className={`tab-btn ${activeTab === 'Election' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Election' src='../images/mayor.png' /> Election<strong className="live-count">{getCount('Election')}</strong></span>
            <span onClick={()=>handleTab("Kabaddi")} className={`tab-btn ${activeTab === 'Kabaddi' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Kabaddi' src='../images/kabaddi.png' /> Kabaddi<strong className="live-count">{getCount('Kabaddi')}</strong></span>
            <span onClick={()=>handleTab("HorseRacing")} className={`tab-btn ${activeTab === 'HorseRacing' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Horse Racing' src='../images/horse.png' /> Horse Racing<strong className="live-count">{getCount('HorseRacing')}</strong></span>
            <span onClick={()=>handleTab("GreyhoundRacing")} className={`tab-btn ${activeTab === 'GreyhoundRacing' ? 'active' :''}`}><img decoding="async" loading="lazy" alt='Greyhound Racing' src='../images/dog.png' /> Greyhound Racing<strong className="live-count">{getCount('GreyHound')}</strong></span>
        </div>
        <AllsportdataTest matchData={matchdata} selectedTypes={selectedTypes} />
    </div>



    <div className='right-content sidebar'>
    {(loggedIn || sessionStorage.getItem('userId')) ? 
        <div className="sidebar-box">
                <div className="title">Open Bets ({getAllBets && (loggedIn || sessionStorage.getItem('userId')) ? getAllBets.length :'0'})</div>
                <div className='betlist'>
                    <table className="betlist-table">
                      <thead>
                          <tr>
                            <th>Selection</th>
                            <th>Odds</th>
                            <th>Market</th>
                            <th>Stake</th>
                          </tr>
                      </thead>
                      <tbody>
                      {getAllBets && (loggedIn || sessionStorage.getItem('userId')) && getAllBets.length > 0 ? (
                        getAllBets.map((item, index) => (
                          <tr id={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}`} key={index}>
                            <td>{item.selectionName}</td>
                            <td>{item.oddValue}</td>
                            <td>{item.marketName}</td>
                            <td>{item.Stake}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" style={{ textAlign: 'center'}}>
                            No bets found
                          </td>
                        </tr>
                      )}
                      </tbody>
                    </table>
                </div>
              </div>
    :
    <div className="sidebar-box">
                <div className="title">All Casino</div>
                <div className="sidebar-card">
                   <Link to="/Royal_casino">
                                      {" "}
                                      <img decoding="async" loading="lazy" alt='' src={`${localStorage.getItem("adminurl")}sliderImages/RoyalGamings.webp`} />
                                    </Link>
                                    <Link to="/live_casino">
                                      {" "}
                                      <img decoding="async" loading="lazy" alt='' src={`${localStorage.getItem("adminurl")}sliderImages/Ezugi.webp`} />
                                    </Link>
                                    <Link to="/slots">
                                      {" "}
                                      <img decoding="async" loading="lazy" alt='' src={`${localStorage.getItem("adminurl")}sliderImages/Slots.webp`} />
                                    </Link>
                                    <Link to="/live_casinoInPlay/65b75f62101c7f8b01f9031a">
                                      {" "}
                                      <img decoding="async" loading="lazy" alt='' src={`${localStorage.getItem("adminurl")}sliderImages/Aviator.webp`} />
                                    </Link>
                </div>
              </div>}
    
    </div>
    </div>
</Container>
  )
}

export default Inplay